import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/android-chrome-512x512.png")